import axios from "axios";

import CreateDataRetrievalBegunAction from "./CreateDataRetrievalBegunAction";
import CreateDataRetrievalEndedAction from "./CreateDataRetrievalEndedAction";
import CreateGetLicenceImagesAction from "./CreateGetLicenceImagesByLicenceIdAction";

export default function uploadOperatorCertificateImage(file) {
    return (dispatch, getState) => {
        dispatch(CreateDataRetrievalBegunAction());

        const { currentApplication } = getState();
        const licenceApplicationId = Number(currentApplication.id);

        const formData = new FormData();
        formData.append("image", file);

        axios({
            method: "POST",
            url: `api/FileUpload/UploadOperatorCertificateImage?licenceApplicationId=${licenceApplicationId}`,
            data: formData,
            headers: { "Content-Type": "multipart/form-data" },
            withCredentials: true
        })
            .then((response) => {
                dispatch(CreateGetLicenceImagesAction(licenceApplicationId));
                dispatch(CreateDataRetrievalEndedAction());
            })
            .catch((error) => {
                console.error("Upload failed:", error);
                dispatch(CreateDataRetrievalEndedAction());
            });
    };
}